import React from "react";
import { Spin } from 'antd';
//import 'antd/dist/antd.css';
export const Spinner = props => {  

  
  return (
    <div className="fp-container">
    <Spin size="large" className="fp-loader" spinning={true} />
  </div>
  );
}

export const ModalSpinner = props => {  

  
  return (
    <div className="modalSpinner">
    <Spin size="large"  spinning={true} />
  </div>
  );
}
